
import { Browse } from "@/models/browse";
import { Model } from "@/utils/models/model";
import { ViewTotal } from "@/utils/views/view-total";
import Vue from "vue";
import AppTotalEditStyle from "./TotalEditStyle.vue";
import AppTotalEditColumns from "./TotalEditColumns.vue";
import AppTotalEditFilters from "./TotalEditFilters.vue";
import AppTotalEditConditions from "./TotalEditConditions.vue";

export default Vue.extend({
	data(){
		return {
			currentTab: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>ViewTotal,
			required: true
		},
		browse: {
			type: Object as ()=>Browse,
			required: true
		},
		edit: {
			type: Boolean
		},
	},
	computed: {
		model():Model{
			return this.browse.type;
		},
		title():string {
			if (this.edit) {
				return "edit-total";
			}
			return "add-total";
		},

	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("save");
		}
	},
	components: {
		AppTotalEditStyle,
		AppTotalEditColumns,
		AppTotalEditFilters,
		AppTotalEditConditions
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
